import Disableable, { Disable, Enable } from '../../../../../../interface/Disableable.js';
import EL, { HTMLELEMENT } from '../../../../../EL/EL.js';
import { OPTION, Select } from '../../../../../DOM/form/fieldset/field/optgroup/OPTGROUP.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
import FIELD from '../../../../../DOM/form/fieldset/field/FIELD.js';
// Model Structure
export const selectAttr = makeAttrStruct([
    ['name'],
    ['multiple', false],
    ['size', 1],
    ['disabled']
]);
export const selectData = makeDataStruct([
    ['options', []],
    ['optgroups', []]
    // ['selectedOptions', []]
]);
export const selectModel = makeStruct([
    ['attributes', selectAttr],
    ['data', selectData]
]);
// Simplified Model
export function select(name, multiple, size, disabled, options, optgroups) {
    return {
        attributes: selectAttr(name, multiple, size, disabled),
        data: selectData(options, optgroups)
    };
}
/** A SELECT element */
export default class SELECT extends FIELD {
    constructor(node, model) {
        super(node, HTMLELEMENT.SELECT, model);
        this.implement(new Disableable(this));
        // if (model.attributes.multiple) {
        // 	this.setAttribute('multiple', true);
        // } else {
        // 	this.removeAttribute('multiple');
        // }
        // model.data.optgroups?.forEach((optgroup: OptGroupElementModel) => this.addOptGroup(optgroup));
        // // For each model.data.option:
        // // - If model.data.option.data.optgroupname is defined, create an OPTGROUP with that name and then call OPTGROUP.addOption to add the OPTION to that OPTGROUP
        // // - If model.data.option.data.optgroupname is not defined, add the OPTION
        // model.data.options?.forEach((opt: OptionElementModel) => {
        // 	if (opt.data?.optgroupname) {
        // 		let optgroup = this.getOptGroups(opt.data.optgroupname)[0];
        // 		optgroup = optgroup || this.addOptGroup(
        // 			optgroupModel(
        // 				optgroupAttr(opt.data.optgroupname, opt.data.optgroupname)
        // 			)
        // 		);
        // 		if (!optgroup) {
        // 			throw new Error(`Unable to create optgroup for option: ${opt.data.text}`);
        // 		}
        // 		optgroup.addOption(opt);
        // 	} else if (opt.data?.optgroupname === undefined) {
        // 		// If no optgroupname, add directly to the select
        // 		// Check if the option already exists in the select
        // 		let existingOption = this.getOptions(opt.data.text)[0];
        // 		if (existingOption) {
        // 			// If it exists, update its value
        // 			existingOption.setValue(opt.data.text);
        // 		} else {
        // 			// If it doesn't exist, add it
        // 			this.addOption(opt);
        // 		}
        // 	}
        // });
    }
    // addOptGroup(model: OptGroupElementModel): OPTGROUP<OptGroupElementModel> {
    // 	let group = new OPTGROUP(this, model);
    // 	this.addChild<OPTGROUP<OptGroupElementModel>>(group);
    // 	return group;
    // }
    // getOptGroups(name: string): OPTGROUP<OptGroupElementModel>[] {
    // 	return this.get<OPTGROUP<OptGroupElementModel>>(name, 'OPTGROUP');
    // }
    addOption(option) {
        let opt = new OPTION(this, option);
        this.addChild(opt);
        return opt;
    }
    /** Retrieves an array of OPTION elements, optionally filtered by name */
    getOptions(name) {
        let options = [];
        options = options.concat(this.get(name, 'OPTION'));
        // Recursively check within OPTGROUPs
        let optgroups = this.get(null, 'OPTGROUP');
        optgroups.forEach((group) => {
            options = options.concat(group.get(name, 'OPTION'));
        });
        return options;
    }
    /** Return the label for the selected OPTION Element */
    getSelectedOptionLabel() {
        return this.el.options[this.el.selectedIndex].label;
    }
    getValue() {
        return this.el.options[this.el.selectedIndex].value;
    }
    setValue(value) {
        const strValue = String(value);
        let found = false;
        for (let i = 0; i < this.el.options.length; i++) {
            if (this.el.options[i].value === strValue) {
                this.el.selectedIndex = i;
                found = true;
                break;
            }
        }
        if (!found) {
            console.warn(`Value "${strValue}" not found in select options.`);
            this.el.selectedIndex = -1;
        }
    }
    selectOption(option) {
        let opt = this.getOptions(option.data.text)[0];
        if (opt) {
            opt.do(new Select(this));
        }
        else {
            console.warn('Option not found:', option.data.text);
        }
    }
    getSelectedIndex() {
        return this.el.selectedIndex || -1;
    }
    checkValidity() {
        // Check if the element is valid according to HTML5 validation
        if (!this.el.checkValidity()) {
            return false;
        }
        // Additional custom validation logic
        const isRequired = this.el.hasAttribute('required');
        const hasSelection = this.el.selectedIndex >= 0;
        const selectedValue = hasSelection ? this.el.value : '';
        // If required but no valid selection
        if (isRequired && (!hasSelection || selectedValue === '')) {
            return false;
        }
        // Check if multiple is required but only one or no options selected
        if (this.getAttribute('multiple') && isRequired) {
            const selectedOptions = Array.from(this.el.selectedOptions);
            if (selectedOptions.length <= 1) {
                return false;
            }
        }
        return true;
    }
    setCustomValidity(message) {
        this.el.setCustomValidity(message);
    }
}
export { Disable, Disableable, EL, Enable };
